import React from 'react';
import { Button } from 'react-bootstrap';

import { getNameInCurrentLanguage } from 'helpers/intl';
import { categories } from 'helpers/items';

import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormCodeEditor from 'components/forms/FormCodeEditor';

export default class CmsElementCommerceProducts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSelectCategory: false,
    };
  }

  setCategory = (name, category) => {
    const { appIntl, setParams } = this.props;

    if (category) {
      setParams([
        { name: 'categoryName', value: getNameInCurrentLanguage(category.name, appIntl) },
        { name: 'categoryPath', value: category.path },
        { name: 'categoryId', value: category.id },
      ]);
      this.setState({ showSelectCategory: false });
    } else {
      setParams([
        { name: 'categoryName', value: null },
        { name: 'categoryPath', value: null },
        { name: 'categoryId', value: null },
      ]);
    }
  };

  render() {
    const {
      intl: { messages },
      getParamValue,
      setParam,
      navigateBack,
    } = this.props;
    const { showSelectCategory } = this.state;

    const categoryId = getParamValue('categoryId', categories.passengerVehicles);
    const sort = getParamValue('sort', 'cdate');

    return (
      <>
        <div className="m-b-20">
          <a
            href="#back"
            className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-5 p-b-5 text-master b-rad-lg"
            onClick={navigateBack}
          >
            <i className="fa fa-angle-left m-r-5" /> {messages.back}
          </a>

          <b>{messages.products}</b>
        </div>

        <div class="form-group-attached">
          {!categoryId || showSelectCategory ? (
            <FormAutocomplete
              name="category"
              autocompleteType="category"
              label={messages.category}
              returnValueObject
              onChange={this.setCategory}
              value={categoryId}
            />
          ) : (
            <div class="form-group form-group-default padding-10">
              <label>{messages.category}</label>
              <span>{getParamValue('categoryName')}</span>
              <Button
                class="m-l-10 btn-rounded"
                bsSize="xs"
                onClick={() => this.setState({ showSelectCategory: true })}
              >
                {messages.change_category}
              </Button>
            </div>
          )}

          <FormAutocomplete
            name="layoutVersion"
            label={messages.layout_version}
            value={getParamValue('layoutVersion', 'slider')}
            onChange={setParam}
            options={[
              { value: 'slider', label: messages.layout_slider },
              { value: 'list', label: messages.layout_list },
            ]}
          />

          <FormAutocomplete
            name="sort"
            label={messages.do_sort}
            options={[
              { label: messages.sort.cdate, value: 'cdate' },
              { label: messages.sort.priceAsc, value: 'priceAsc' },
              { label: messages.sort.priceDesc, value: 'priceDesc' },
            ]}
            onChange={setParam}
            value={sort}
          />

          <FormCodeEditor
            name="urlParams"
            label={messages.json_url_parameters}
            value={getParamValue('urlParams')}
            onChange={setParam}
            language="javascript"
          />
          <FormInput
            name="minImageCount"
            label={'Mindestanzahl der Bilder'}
            value={getParamValue('minImageCount', 0)}
            onChange={setParam}
            type="number"
          />
        </div>
      </>
    );
  }
}
